import script from "./VideoConsultation.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoConsultation.vue?vue&type=script&setup=true&lang=ts"

import "./VideoConsultation.vue?vue&type=style&index=0&id=5af45c08&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af45c08"]])

export default __exports__